<template>
  <div>
    <div class="flex input-group">
      <select v-model="selectedOrderAccess.project" class="custom-select">
        <option value="all">Все проекты</option>
        <option v-for="project in $AllProjects" v-if="project.id" :value="project.id">{{ project.name }}</option>
      </select>
      <SortedCitySelect
        :onUpdate="(cityId) => selectedOrderAccess.city = cityId"
      />
      <button @click="addSelected" class="btn btn-outline-success btn-sm">Добавить</button>
    </div>
    <div class="mt-2" v-if="accessRecords && accessRecords.length > 0">
      <table class="table table-sm table-hover">
        <thead>
        <tr>
          <th>Проект</th>
          <th>Направление</th>
          <th v-if="visibilitySelect">Видимость</th>
          <th v-if="useCustomRate">Коэффициент</th>
          <th></th>
        </tr>
        </thead>
        <tbody>
        <template v-for="(record, index) in accessRecords">
          <tr v-if="record.city_id !== undefined">
            <td width="100">{{
                record.project_id === 'all' ? 'Все проекты' : $AllProjects[record.project_id].name
              }}
            </td>
            <td>{{ record.cityName }}</td>
            <td v-if="visibilitySelect">
              <input type="checkbox" v-model="record.visibleForAgent">
            </td>
            <td v-if="useCustomRate">
              <input type="number" class="form-control" v-model="record.customRate">
            </td>
            <td width="70" class="text-right">
              <button @click="remove(index)" class="btn btn-xs btn-danger"><i
                class="icon-fa icon-fa-remove text-center"></i></button>
            </td>
          </tr>
        </template>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>

import SortedCitySelect from "@/components/cities/SortedCitySelect";

export default {
  props: ['selected', 'visibilitySelect', 'updateRecords', 'useCustomRate'],
  components: {
    SortedCitySelect
  },
  computed: {
    $AllCities() {
      const cities = this.$store.getters['platform/cities'];
      cities[0] = {
        name: 'Почта',
        id: 0
      };
      return cities;
    },
    $AllProjects() {
      return this.$store.getters['platform/projects'].reduce((acc, p) => {
        acc[p.id] = p
        return acc;
      }, {});
    },
  },
  data() {
    return {
      accessRecords: [],
      selectedOrderAccess: {
        project: 'all',
        city: 'all'
      },
    }
  },
  mounted() {
    this.accessRecords = this.getSorted(this.selected);
  },
  watch: {
    'selected': {
      handler: function (val, oldVal) {
        this.accessRecords = this.getSorted(this.selected);
      },
      deep: true
    },
    'accessRecords': {
      handler: function (val, oldVal) {
        // if (this.incomeDrug && this.incomeDrug.id) this.drug = this.incomeDrug;
        // this.syncRecords();
      },
      deep: true
    },
  },
  methods: {
    getSorted(records) {
      const r = records.reduce((acc, record) => {
        acc.push({
          ...record,
          cityName: record.city_id === 'all' ? 'Все города' : record.city_id !== undefined && this.$AllCities[record.city_id].name
        });
        return acc;
      }, []);
      return _.orderBy(r, 'cityName');
    },
    addSelected() {
      const added = this.accessRecords.find((r) => r.project_id === this.selectedOrderAccess.project && r.city_id === this.selectedOrderAccess.city);
      if (added) return;
      let records = [...this.accessRecords];

      let allIncluded = records.find((r) => r.project_id === 'all' && r.city_id === 'all');
      if (allIncluded) return;
      if (this.selectedOrderAccess.project === 'all' && this.selectedOrderAccess.city === 'all') {
        records = records.filter((r) => !r.city_id);
        // } else if (this.selectedOrderAccess.project === 'all') {
        //   records = records.filter((r) => !(r.city_id === this.selectedOrderAccess.city));
        // } else if (this.selectedOrderAccess.city === 'all') {
        //   records = records.filter((r) => !(r.project_id === this.selectedOrderAccess.project));
      } else {
        let allIncluded = records.find((r) => r.project_id === 'all' && r.city_id === 'all');
        if (allIncluded) return;
        let allCities = records.find((r) => r.project_id === this.selectedOrderAccess.project && r.city_id === 'all');
        if (allCities) return;
        let allProjects = records.find((r) => r.city_id === this.selectedOrderAccess.city && r.project_id === 'all');
        if (allProjects) return;
      }

      records.push({
        project_id: this.selectedOrderAccess.project,
        city_id: this.selectedOrderAccess.city,
        cityName: this.selectedOrderAccess.city === 'all' ? 'Все города' : this.$AllCities[this.selectedOrderAccess.city].name,
        customRate: 0,
        visibleForAgent: false,
      });
      this.accessRecords = records;
      this.syncRecords();
    },
    remove(index) {
      let records = [...this.accessRecords];
      delete records[index];
      this.accessRecords = records.filter((r) => r);
      this.syncRecords();
    },
    syncRecords() {
      if (this.updateRecords) {
        this.updateRecords([...this.accessRecords]);
      }
    }
  }
}
</script>
